import React from 'react';

import alertIcon from '../../../../assets/petDemos/alert-error-red-bold.svg';

import styles from './InputWithTitle.module.css';

const InputWithTitle = ({
  error = '',
  name = '',
  onChange = () => { },
  placeholder = '',
  disabled = false,
  title = '',
  type = 'text',
  value = '',
}) => (
  <div className={styles.mainContainer}>
    <label htmlFor={name}>{title}</label>

    <input
      data-error={!!error}
      disabled={disabled}
      id={name}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      type={type}
      value={value}
    />

    {error && (
      <div className={styles.rowError}>
        <img alt="" src={alertIcon} />

        <span className={styles.errorLabel}>{error}</span>
      </div>
    )}
  </div>
);

export { InputWithTitle };
